export class RdApplicationDeniedDetails {
  taxYear: string;
  reasonTitle: string;
  reasonDescription: string;
}
